import { createRouter, createWebHistory } from 'vue-router'
import { useUserStore } from '@/stores/user'
import Layout from '../views/layout/index.vue'
import Approvals from '../views/approvals/index.vue'
import History from '../views/history/index.vue'
import ApprovalsDetail from '../views/approvalsDetail/index.vue'
import OfficePreview from '../views/approvalsDetail/OfficePreview.vue'
import Dashboard from '../views/dashboard/index.vue'

const routes = [
  {
    path: '/',
    component: Layout,
    redirect: '/approvals',
    children: [
      { path: 'home', component: Dashboard },
      { path: 'approvals', component: Approvals },
      { path: 'history', component: History },
    ],
  },
  {
    path: '/approvalsDetail',
    component: ApprovalsDetail
  }
  ,
  {
    path: '/officePreview',
    component: OfficePreview
  }
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: routes,
})

router.beforeEach(async (to) => {
  const path = to.path.replace(/\/$/, '') || '/'
  if (path === '/home') {
    const userStore = useUserStore()
    await userStore.loadUser()
    if (!userStore.showHomePage) {
      return { path: '/approvals', replace: true }
    }
  }
})

export default router
